import { Box, Typography } from '@mui/material';
import React from 'react';
import { STATUS_SALE } from '../../../../helpers/enums';
import { ccyFormat } from '../../../../helpers/helper';

const MixedPaymentsDetail = ({ sale, getPendingBySale }) => (
    <>
        {sale.status === STATUS_SALE.RESERVED && sale.deposit > 0 && <Box display='flex' flexDirection='row' justifyContent='space-between'>
            <Typography variant='caption'>Debe:</Typography>
            <Typography variant='caption'>{`$ ${ccyFormat(getPendingBySale(sale))}`}</Typography>
        </Box>}
        <Box display='flex' flexDirection='row' justifyContent='space-between'>
            <Typography variant='caption'>Depósito:</Typography>
            <Typography variant='caption'>{`$ ${ccyFormat(sale.deposit)}`}</Typography>
        </Box>
        <Box display='flex' flexDirection='row' justifyContent='space-between'>
            <Typography variant='caption'>Efectivo:</Typography>
            <Typography variant='caption'>{`$ ${ccyFormat(sale.payments.find(p => p.name === "Efectivo").amount)}`}</Typography>
        </Box>
        <Box display='flex' flexDirection='row' justifyContent='space-between'>
            <Typography variant='caption'>Transferencia:</Typography>
            <Typography variant='caption'>{`$ ${ccyFormat(sale.payments.find(p => p.name === "Transferencia").amount)}`}</Typography>
        </Box>
    </>
)

export default MixedPaymentsDetail;
